import styled from '@emotion/styled';
import type { FC, PropsWithChildren } from 'react';

import { Anchor } from 'src/components/common/atoms';
import { media } from 'src/styles';

type Props = PropsWithChildren & {
  className?: string;
  to?: string;
};

export const Item: FC<Props> = ({ className, to, children }) => {
  return (
    <Wrapper className={className ?? ''}>
      {to ? (
        <StyledAnchor to={to}>{children}</StyledAnchor>
      ) : (
        <span>{children}</span>
      )}
    </Wrapper>
  );
};

const StyledAnchor = styled(Anchor)`
  text-decoration: none;
  &:hover,
  &:focus-visible {
    text-decoration: underline;
  }
`;

const Wrapper = styled.li`
  line-height: 1;
  font-family: ${({ theme }) => theme.font.family.english};
  font-size: ${({ theme }) => theme.font.size.medium};
  ${media.greaterThanSiteBreakpoint} {
    line-height: 1.4;
  }
`;

export default Item;
